export const ClientProgressBar = ({
  value = 0,
  max = 100
}) => {
  return <progress className="fancy-progress-bar" value={value} max={max} />;
};